import React, { useEffect, useState } from "react";
import {
  Box, Typography, Card, CardContent, Grid, Button, Paper, useTheme, useMediaQuery, IconButton, Avatar, LinearProgress, Badge,
  Divider, Grow, Fade, Tooltip, TextField, Autocomplete
} from "@mui/material";
import {
  Add as AddIcon,
  ArrowForward as ArrowForwardIcon,
  Refresh as RefreshIcon,
  FilterList as FilterIcon,
  MoreVert as MoreIcon,
  TrendingUp as TrendingUpIcon,
  CheckCircle as CheckCircleIcon,
  Pending as PendingIcon,
  DoneAll as DoneAllIcon,
  Equalizer as EqualizerIcon,
  KeyboardBackspace as KeyboardBackspaceIcon,
  Pause as PauseIcon
} from "@mui/icons-material";
import {
  AssignmentInd as TaskAssignIcon,
  TrackChanges as TaskStatusIcon,
  AssignmentTurnedIn as TaskAcceptIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../../lib/axios";
import LiveTicketsGraph from "./WeeklyTicketsGraph";
// import TktTableLive from "./TktTableLive";
// import TktTableOverTime from "./TktTableOverTime";
import TktOvrTimeGraph from "./TktOvrTimeGraph";
import { selectGlobalProperty } from "../../../../redux/propertySlice";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import MultipleCards from "./MultipleCards";
import {
  AssignmentLate as AssignmentLateIcon,
  DoneAll as DoneAllIcon2,
  Cancel as CancelIcon2,
  HourglassEmpty as HourglassEmptyIcon,
  Autorenew as AutorenewIcon2,
} from "@mui/icons-material";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import AssessmentIcon from "@mui/icons-material/Assessment";
import Chip from "@mui/material/Chip";
import TicketDialog from "./CardsDialog/TicketDialog";
import UnassignedTktDlog from "./CardsDialog/UnassignedTktDlog";
import InProgTktDlog from "./CardsDialog/InProgTktDlog";
import ClosedTktDlog from "./CardsDialog/ClosedTktDlog";
import ResolvTktDlog from "./CardsDialog/ResolvTktDlog";

import { selectPermissions } from "../../../../redux/permissionsSlice"; 

const statusIcons = {
  "Open": <AssignmentLateIcon fontSize="large" />,
  "In Progress": <PendingIcon fontSize="large" />,
  "Hold": <PauseCircleOutlineIcon fontSize="large" />,
  "Closed": <CheckCircleIcon fontSize="large" />,
  "Resolved": <DoneAllIcon fontSize="large" />,
  "Total Tickets": <EqualizerIcon fontSize="large" />
};

const titleToStatus = {
  "Open": "O",
  "In Progress": "I",
  "Hold": "H",
  "Resolved": "R",
  "Closed": "C",
  "Total Tickets": ""
};

const titleToDialogType = {
  "Open": "open",
  "In Progress": "inProgress",
  "Hold": "hold",
  "Resolved": "resolved",
  "Closed": "closed",
  "Total Tickets": "total"
};

const getStatusText = (status) => {
  switch (status) {
    case "O":
      return "Open";
    case "I":
      return "In Progress";
    case "H":
      return "Hold";
    case "R":
      return "Resolved";
    case "C":
      return "Closed";
    default:
      return "Unknown";
  }
};

const DashTicket = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const [dialogType, setDialogType] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lastUpdated, setLastUpdated] = useState(new Date());
  const [statsHover, setStatsHover] = useState(null);
  const globalProperty = useSelector(selectGlobalProperty);
  const [rows, setRows] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("O");
  const currentDate = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(currentDate.getMonth() - 1);
  const formatDateForInput = (date) => date.toISOString().split("T")[0];
  const [fromDate, setFromDate] = useState(formatDateForInput(oneMonthAgo));
  const [toDate, setToDate] = useState(formatDateForInput(currentDate));
  const [searchTerm, setSearchTerm] = useState("");
  const [categories, setCategories] = useState([]);
  const [warden, setWarden] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedWarden, setSelectedWarden] = useState(null);
  const [isInitialFetch, setIsInitialFetch] = useState(true);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [selectedRowCategoryId, setSelectedRowCategoryId] = useState(null);
const permissions = useSelector(selectPermissions);

const hasModulePermission = (moduleName) => {
    const modulePermission = permissions.find(
      (permission) => permission.ModuleName === moduleName
    );

    if (!modulePermission) return false;

    return (
      modulePermission.AddRec === "1" ||
      modulePermission.EditRec === "1" ||
      modulePermission.DeleteRec === "1" ||
      modulePermission.ViewRec === "1"
    );
  };
  // Ticket details with icons
  const [ticketDetails, setTicketDetails] = useState([
    { title: "Open", value: 0, color: theme.palette.error.main, trend: 12.5 },
    { title: "In Progress", value: 5, color: "#FF9800", trend: 12.5 },
    { title: "Hold", value: 0, color: "#8E24AA", trend: 0 },
    { title: "Closed", value: 2, color: '#FF5722', trend: -3.2 },
    { title: "Resolved", value: 3, color: "#4CAF50", trend: 8.1 },
    { title: "Total Tickets", value: 10, color: theme.palette.primary.main, trend: 5.7 },
  ]);

  const fetchCardData = async () => {
    try {
      if (!globalProperty || !selectedCategory?.Id || !selectedWarden?.Id) {
        setTicketDetails([
          { title: "Open", value: 0, color: theme.palette.error.main, trend: 0 },
          { title: "In Progress", value: 0, color: "#FF9800", trend: 0 },
          { title: "Hold", value: hold, color: "#8E24AA", trend: 0 },
          { title: "Resolved", value: 0, color: '#FF5722', trend: 0 },
          { title: "Closed", value: 0, color: "#4CAF50", trend: 0 },
          { title: "Total Tickets", value: 0, color: '#00ACC1', trend: 0 },
        ]);
        setLastUpdated(new Date());
        return;
      }

      const response = await axiosInstance.post("TrnTicketing/GetFilterTicketDashBoard", {
        PageNumber: 1,
        PageSize: 10,
        PropId: globalProperty,
        Id: selectedCategory.Id,
        WardenId: selectedWarden.Id,
        ServiceProvId: 1,
        SearchText: "",
        SearchFrom: fromDate,
        SearchTo: toDate,
        Flag: "PropStatusCount",
      });
      const { Status, Data, Message } = response.data;
      // Reset to zero first
      let open = 0;
      let inProgress = 0;
      let hold = 0;
      let closed = 0;
      let resolved = 0;

      if (Status === 0 && Array.isArray(Data) && Data.length > 0) {
        Data.forEach((ticket) => {
          if (ticket.Status === "O") open += ticket.TotalCount || 0;
          else if (ticket.Status === "I") inProgress += ticket.TotalCount || 0;
          else if (ticket.Status === "H") hold += ticket.TotalCount || 0;
          else if (ticket.Status === "C") closed += ticket.TotalCount || 0;
          else if (ticket.Status === "R") resolved += ticket.TotalCount || 0;
        });
      }

      const total = open + inProgress + hold + closed + resolved;

      const calculatePercentage = (value) => (total > 0 ? ((value / total) * 100).toFixed(2) : 0);

      setTicketDetails([
        { title: "Open", value: open, color: theme.palette.error.main, trend: calculatePercentage(open) },
        { title: "In Progress", value: inProgress, color: "#FF9800", trend: calculatePercentage(inProgress) },
        { title: "Hold", value: hold, color: "#9C27B0", trend: calculatePercentage(hold) },
        { title: "Resolved", value: resolved, color: '#FF5722', trend: calculatePercentage(resolved) },
        { title: "Closed", value: closed, color: "#4CAF50", trend: calculatePercentage(closed) },
        { title: "Total Tickets", value: total, color: '#00ACC1', trend: calculatePercentage(total) },
      ]);

      setLastUpdated(new Date());
    } catch (error) {

      // Reset on error too
      setTicketDetails([
        { title: "Open", value: 0, color: theme.palette.error.main, trend: 0 },
        { title: "In Progress", value: 0, color: "#FF9800", trend: 0 },
        { title: "Hold", value: 0, color: "#9C27B0", trend: 0 },
        { title: "Resolved", value: 0, color: '#FF5722', trend: 0 },
        { title: "Closed", value: 0, color: "#4CAF50", trend: 0 },
        { title: "Total Tickets", value: 0, color: '#00ACC1', trend: 0 },
      ]);

      toast.error("Failed to load ticket stats.");
    } finally {
      setLoading(false);
    }
  };

  const handleGetData = () => {
    if (!globalProperty) {
      toast.error("Property is not set.", {
        autoClose: 1000,
      });
      return;
    }

    if (!selectedCategory || typeof selectedCategory !== "object" || !selectedCategory.Id) {
      toast.warn("Please select a category.", {
        position: "top-center",
        autoClose: 1500,
      });
      return;
    }
    setSelectedStatus("");
    fetchTickets("O");
    fetchCardData();
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (globalProperty && selectedCategory?.Id && selectedWarden?.Id) {
        if (isInitialFetch) {
          fetchTickets("O");
          setIsInitialFetch(false);
        }
        fetchCardData();
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [globalProperty, selectedCategory, selectedWarden, fromDate, toDate]);

  const fetchTickets = async (overrideStatus = selectedStatus) => {
    try {
      if (!globalProperty || !selectedCategory?.Id) {
        toast.error("Property or category is not set.");
        return;
      }
      const response = await axiosInstance.post("TrnTicketing/GetFilterTicketDashBoard",
        {
          PageNumber: 1,
          PageSize: 10,
          PropId: globalProperty,
          Id: selectedCategory.Id,
          WardenId: selectedWarden?.Id || 1,
          ServiceProvId: 1,
          SearchText: overrideStatus,
          SearchFrom: fromDate,
          SearchTo: toDate,
          Flag: "TicketDash",
        }
      );

      const { data: { Status, Data }, } = response;

      if (Status === 0 && Array.isArray(Data)) {
        setRows(Data);
        if (Data.length > 0) {
          setSelectedTicket(Data[0]);
        } else {
          setSelectedTicket(null);
        }
      } else {
        setRows([]);
        setSelectedTicket(null);
      }
    } catch (error) {
      setRows([]);
      setSelectedTicket(null);
      toast.error("Error fetching tickets. Please try again.");
    }
  };

  const handleCategoryChange = (event, newValue) => {
    setSelectedCategory(newValue ?? null);
    setSelectedRows([]);
    setSelectedCategoryId(null);
  };

  const handleWardenChange = (event, newValue) => {
    setSelectedWarden(newValue ?? null);
    setSelectedRows([]);
    setSelectedCategoryId(null);
  };

  useEffect(() => {
    const fetchWardenName = async () => {
      if (!globalProperty) return;

      try {
        const response = await axiosInstance.post(`TrnTicketing/getPropertyWisedrp`, {
          PropId: globalProperty,
          Flag: "RaisedBy",
        });
        const { data: { Status, Data }, } = response;
        if (Status === 0 && Array.isArray(Data) && Data.length > 0) {
          const allWarden = { Id: 1, Name: "All" };
          setWarden([allWarden, ...Data]);
          setSelectedWarden(allWarden);
        } else {
          setWarden([]);
          setSelectedWarden(null);
        }
      } catch (error) {
        setWarden([]);
        setSelectedWarden(null);
      }
    };

    fetchWardenName();
  }, [globalProperty]);

  useEffect(() => {
    const fetchCategoryName = async () => {
      if (!globalProperty) return;

      try {
        const response = await axiosInstance.post(`TrnTicketing/getPropertyWisedrp`, {
          PropId: globalProperty,
          flag: "Cat",
        });
        const { data: { Status, Data }, } = response;

        if (Status === 0 && Array.isArray(Data) && Data.length > 0) {
          const allCategory = { Id: 1, Name: "All" };
          setCategories([allCategory, ...Data]);
          setSelectedCategory(allCategory);
        } else {
          setCategories([]);
          setSelectedCategory(null);
        }
      } catch (error) {
        setCategories([]);
        setSelectedCategory(null);
      }
    };
    fetchCategoryName();
  }, [globalProperty]);

  useEffect(() => {
    const interval = setInterval(fetchCardData, 60000); // Refresh every 1 minute
    return () => clearInterval(interval);
  }, [globalProperty, selectedCategory, selectedWarden, fromDate, toDate]);

  const handleCreateTicket = () => {
    navigate("/raise-service-tkt");
  };

  const handleOpenDialog = (type) => {
    setDialogType(type);
  };

  const handleCloseDialog = () => {
    setDialogType(null);
  };

  const handleRowClick = (row) => {
    setSelectedTicket(row);
    setSelectedRowCategoryId(row.TktCategoryId);
  };

  const getStatusChip = (status) => {
    let color, icon, bgColor;
    switch (status) {
      case "O":
        color = "error";
        icon = <HourglassEmptyIcon fontSize="small" />;
        bgColor = theme.palette.error.main;
        break;
      case "I":
        color = "warning";
        icon = <AutorenewIcon2 fontSize="small" />;
        bgColor = '#FF9800';
        break;
      case "H":
        color = "warning";
        icon = <PauseIcon fontSize="small" />;
        bgColor = '#9c27b0';
        break;
      case "R":
        color = "default";
        icon = <DoneAllIcon2 fontSize="small" />;
        bgColor = '#FF5722';
        break;
      case "C":
        color = "success";
        icon = <CancelIcon2 fontSize="small" />;
        bgColor = "#4CAF50";
        break;
      default:
        color = "default";
        icon = null;
        bgColor = theme.palette.grey[200];
    }
    return (
      <Chip
        icon={icon}
        label={getStatusText(status)}
        color={color}
        size="small"
        sx={{
          fontWeight: 600,
          borderRadius: "12px",
          backgroundColor: bgColor,
          color: theme.palette.getContrastText(bgColor),
          "& .MuiChip-icon": {
            color: theme.palette.getContrastText(bgColor),
            fontSize: { xs: "0.9rem", sm: "0.5", md: "0.8rem" },
          },
          maxWidth: { xs: "110px", sm: "80px", md: "110px" },
          fontSize: { xs: "0.9rem", sm: "0.75rem" },
          padding: { xs: "2px 4px", sm: "4px 0px" },
        }}
      />
    );
  };

  const handleStatusClick = (status) => {
    setSelectedStatus(status);
    setSelectedRows([]);
    setSelectedCategoryId(null);
    fetchTickets(status);
  };

  const StatCard = ({ title, value, color, trend }) => {
    const isPositive = trend >= 0;
    const trendColor = isPositive ? theme.palette.success.main : theme.palette.error.main;
    const isSelected = titleToStatus[title] === selectedStatus;

    return (
      <Card
        aria-selected={isSelected}
        sx={{
          minHeight: '100px',
          borderRadius: '16px',
          background: `linear-gradient(135deg, ${color} 0%, ${theme.palette.augmentColor({ color: { main: color } }).dark} 100%)`,
          color: "white",
          boxShadow: isSelected ? theme.shadows[8] : theme.shadows[4],
          border: isSelected ? `2px solid ${theme.palette.primary.main}` : 'none',
          position: 'relative',
          overflow: 'hidden',
          '&:hover': {
            boxShadow: theme.shadows[8],
            transform: isSelected ? 'none' : 'translateY(-2px)',
          },
          transition: 'all 0.3s ease',
          minWidth: { xs: '100%', sm: 'auto' },
        }}
      >
        <CardContent
          onClick={() => handleStatusClick(titleToStatus[title])}
          sx={{
            position: 'relative',
            zIndex: 1,
            cursor: 'pointer',
            p: 2,
            padding: isSelected ? 'calc(16px - 2px)' : '16px',
          }}
        >
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            width: '100%',
          }}>
            <Box sx={{ maxWidth: '60%' }}>
              <Typography
                variant="subtitle2"
                sx={{
                  opacity: 0.8,
                  mb: 0.5,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  fontSize: { xs: '0.8rem', sm: '0.875rem' },
                }}
              >
                {title}
              </Typography>
              <Typography variant="h3" sx={{ fontWeight: 700, fontSize: { xs: "2rem", sm: "2.2rem", md: "1.5rem" }, }}>
                {value}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                <TrendingUpIcon
                  sx={{
                    transform: isPositive ? 'none' : 'rotate(180deg)',
                    color: trendColor,
                    mr: 0.5
                  }}
                />
                <Typography
                  variant="body2"
                  sx={{
                    color: trendColor,
                    fontWeight: 600,
                    whiteSpace: 'nowrap',
                  }}
                >
                  {Math.abs(trend)}% {isPositive ? 'increase' : 'decrease'}
                </Typography>
              </Box>
            </Box>
            <Tooltip title={isSelected ? "Currently Selected" : "View Details"} arrow>
              <Avatar
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenDialog(titleToDialogType[title]);
                }}
                sx={{
                  bgcolor: isSelected ? theme.palette.primary.main : 'rgba(255,255,255,0.2)',
                  width: 56,
                  height: 56,
                  cursor: 'pointer'
                }}
              >
                {statusIcons[title]}
              </Avatar>
            </Tooltip>
          </Box>
          <Fade in={statsHover === title}>
            <Box sx={{
              position: 'absolute',
              bottom: 16,
              right: 16,
              display: 'flex',
              alignItems: 'center'
            }}>
              <Typography variant="caption" sx={{ opacity: 0.8, mr: 1 }}>
                View details
              </Typography>
              <ArrowForwardIcon fontSize="small" />
            </Box>
          </Fade>
        </CardContent>
      </Card>
    );
  };

  return (
    <Box sx={{
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
      backgroundColor: theme.palette.background.default,
      overflowX: 'hidden',
      paddingBottom: { xs: '15px', md: '0' },
    }}>
      <ToastContainer />
      {loading && (
        <LinearProgress
          color="secondary"
          sx={{
            height: 4,
            '& .MuiLinearProgress-bar': {
              animationDuration: '2s'
            }
          }}
        />
      )}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 2, sm: 2, md: 2 },
          pt: { xs: 4, sm: 2, md: 2 },
          width: { xs: '100%', sm: 'auto', md: 'auto', lg: 'auto' },
          maxWidth: { xs: '100%', sm: 'auto', md: 'auto', lg: 'auto' },
          margin: { xs: '0 auto', md: '0 auto' },
          overflowX: 'hidden',
        }}
      >
        {/* Header Section */}
        <Grow in={!loading} timeout={500}>
          <Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'column', md: 'row' },
                justifyContent: 'space-between',
                alignItems: { xs: 'stretch', sm: 'stretch', md: 'center' },
                mb: 1,
                flexWrap: 'wrap',
                gap: 2,
                width: '100%',
                maxWidth: '100%',
                px: { xs: 1, sm: 2, md: 0 },
                boxSizing: 'border-box',
              }}
            >
              {/* Left Side: Back Button + Title */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: { xs: 2, sm: 2, md: 1 },
                  mb: { xs: 2, sm: 2, md: 0 },
                  minWidth: 0, // Allows text to shrink
                }}
              >
                <Tooltip title="Go Back" arrow>
                  <Avatar
                    sx={{
                      bgcolor: theme.palette.primary.main,
                      width: 50,
                      height: 50,
                      boxShadow: theme.shadows[4],
                      cursor: 'pointer',
                      flexShrink: 0,
                    }}
                    onClick={() => navigate("/service&ticket/complaint")}
                  >
                    <KeyboardBackspaceIcon
                      sx={{
                        fontSize: { xs: 24, sm: 28 },
                        color: "#fff",
                      }}
                    />
                  </Avatar>
                </Tooltip>

                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    minWidth: 0,
                    flex: 1,
                  }}
                >
                  <Typography
                    variant="h5"
                    component="h4"
                    sx={{
                      fontWeight: 800,
                      color: theme.palette.text.primary,
                      lineHeight: 1.2,
                      fontSize: { xs: '1.4rem', sm: '1.5rem', md: '1.6rem' },
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    Ticket Dashboard
                  </Typography>

                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontSize: { xs: '0.9rem', sm: '1rem', md: '1rem' },
                      color: theme.palette.text.secondary,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 0.5,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        width: 8,
                        height: 8,
                        bgcolor: loading
                          ? theme.palette.error.main
                          : theme.palette.success.main,
                        borderRadius: '50%',
                        display: 'inline-block',
                        flexShrink: 0,
                      }}
                    />
                    {loading ? 'Connecting...' : 'Real-time monitoring'}
                  </Typography>
                </Box>
              </Box>

              {/* Right Side: Filters + Buttons */}
              <Grid
                container
                spacing={{ xs: 1.5, sm: 2, md: 1 }}
                alignItems="center"
                sx={{
                  width: "100%",
                  flex: 1,
                  minWidth: 0,
                  flexWrap: { xs: 'wrap', sm: 'wrap', md: 'nowrap' },
                }}
              >
                {/* From Date */}
                <Grid item xs={12} sm={6} md={2}>
                  <TextField
                    label="From Date"
                    type="date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    size="small"
                    fullWidth
                    sx={{
                      "& .MuiInputBase-root": {
                        fontSize: { xs: "0.875rem", sm: "0.875rem" },
                        height: { xs: "40px", sm: "36px" },
                      },
                      "& .MuiInputLabel-root": {
                        fontSize: { xs: "0.875rem", sm: "0.875rem" },
                      },
                    }}
                  />
                </Grid>

                {/* To Date */}
                <Grid item xs={12} sm={6} md={2}>
                  <TextField
                    label="To Date"
                    type="date"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    size="small"
                    fullWidth
                    sx={{
                      "& .MuiInputBase-root": {
                        fontSize: { xs: "0.875rem", sm: "0.875rem" },
                        height: { xs: "40px", sm: "36px" },
                      },
                      "& .MuiInputLabel-root": {
                        fontSize: { xs: "0.875rem", sm: "0.875rem" },
                      },
                    }}
                  />
                </Grid>

                {/* Warden */}
                <Grid item xs={12} sm={6} md={2}>
                  <Autocomplete
                    key={warden.length}
                    options={warden}
                    getOptionLabel={(option) => option.Name || ""}
                    value={selectedWarden}
                    onChange={handleWardenChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="RaisedBy"
                        size="small"
                        fullWidth
                        placeholder={warden.length === 0 ? "No wardens" : "Select warden"}
                        sx={{
                          "& .MuiInputBase-root": {
                            fontSize: { xs: "0.875rem", sm: "0.875rem" },
                            height: { xs: "40px", sm: "36px" },
                          },
                          "& .MuiInputLabel-root": {
                            fontSize: { xs: "0.875rem", sm: "0.875rem" },
                          },
                        }}
                      />
                    )}
                    isOptionEqualToValue={(option, value) => option.Id === value?.Id}
                    noOptionsText="No wardens"
                  />
                </Grid>

                {/* Category */}
                <Grid item xs={12} sm={6} md={2}>
                  <Autocomplete
                    key={categories.length}
                    options={categories}
                    getOptionLabel={(option) => option.Name || ""}
                    value={selectedCategory}
                    onChange={handleCategoryChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Category"
                        size="small"
                        fullWidth
                        placeholder={
                          categories.length === 0 ? "No categories" : "Select category"
                        }
                        sx={{
                          "& .MuiInputBase-root": {
                            fontSize: { xs: "0.875rem", sm: "0.875rem" },
                            height: { xs: "40px", sm: "36px" },
                          },
                          "& .MuiInputLabel-root": {
                            fontSize: { xs: "0.875rem", sm: "0.875rem" },
                          },
                        }}
                      />
                    )}
                    isOptionEqualToValue={(option, value) => option.Id === value?.Id}
                    noOptionsText="No categories"
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={4}
                  sx={{
                    display: "flex",
                    justifyContent: { xs: "center", sm: "center", md: "flex-end" },
                    gap: 1,
                    flexWrap: { xs: "wrap", md: "nowrap" },
                  }}
                >
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleGetData}
                    sx={{
                      borderRadius: "4px",
                      textTransform: "none",
                      fontWeight: "bold",
                      fontSize: { xs: "0.875rem", md: "0.875rem" },
                      height: { xs: "40px", sm: "36px" },
                      minWidth: { xs: "100px", md: "90px" },
                      px: 2,
                      whiteSpace: "nowrap",
                      flex: { xs: 1, md: "unset" },
                    }}
                  >
                    Get Data
                  </Button>

                 
{hasModulePermission("Raise Service Ticket") && (
  <Button
    variant="contained"
    color="primary"
    size="small"
    onClick={handleCreateTicket}
    startIcon={<AddIcon />}
    sx={{
      borderRadius: "4px",
      textTransform: "none",
      fontWeight: "bold",
      fontSize: { xs: "0.875rem", md: "0.875rem" },
      height: { xs: "40px", sm: "36px" },
      minWidth: { xs: "120px", md: "110px" },
      px: 2,
      whiteSpace: "nowrap",
      flex: { xs: 1, md: "unset" },
      boxShadow: theme.shadows[4],
      "&:hover": {
        boxShadow: theme.shadows[8],
        transform: "translateY(-2px)",
      },
      transition: "all 0.3s ease",
    }}
  >
    Create Ticket
  </Button>
)}

                  <Tooltip title="View Ticket Report Table" arrow>
                    <Button
                      variant="contained"
                      color="primary"  // Changed from "secondary" to "primary"
                      size="small"
                      // onClick={() => navigate("/raise-service-tkt-table")}
                      onClick={() => navigate("/ticket")}
                      startIcon={<AssessmentIcon />}
                      sx={{
                        borderRadius: "4px",
                        textTransform: "none",
                        fontWeight: "bold",
                        fontSize: { xs: "0.875rem", md: "0.875rem" },
                        height: { xs: "40px", sm: "36px" },
                        minWidth: { xs: "120px", md: "110px" },
                        px: 2,
                        whiteSpace: "nowrap",
                        flex: { xs: 1, md: "unset" },
                        boxShadow: theme.shadows[4],
                        "&:hover": {
                          boxShadow: theme.shadows[8],
                          transform: "translateY(-2px)",
                        },
                        transition: "all 0.3s ease",
                        backgroundColor: theme.palette.primary.main, // Ensures same bg
                        "&:hover": {
                          backgroundColor: theme.palette.primary.dark,
                          boxShadow: theme.shadows[8],
                          transform: "translateY(-2px)",
                        },
                      }}
                    >
                      Report Table
                    </Button>
                  </Tooltip>
                </Grid>
              </Grid>
            </Box>

            {/* Navigations*/}
            <Box sx={{ mb: 1 }}>
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: { xs: 1.5, sm: 1.5 }, // consistent gap
                  alignItems: "center",
                  // Mobile-specific layout
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: { xs: "stretch", sm: "center" },
                  justifyContent: { xs: "center", sm: "flex-start" },
                  textAlign: { xs: "center", sm: "left" },
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    color: "text.primary",
                    mb: { xs: 1, sm: 1 },
                    width: { xs: "100%", sm: "auto" },
                    textAlign: { xs: "left", sm: "left" },
                  }}
                >
                  Navigations:-
                </Typography>

                {hasModulePermission("Task Assignment") && (
      <Tooltip title={selectedTicket ? "Assign Task" : "Navigate to the Task Assignment page"} arrow>
        <span>
          <Button
            variant="contained"
            size="small"
            startIcon={<TaskAssignIcon />}
            onClick={() => navigate(`/task-assignment`)}
            fullWidth={isMobile}
            sx={{
              borderRadius: "24px",
              textTransform: "none",
              fontWeight: 700,
              height: 36,
              bgcolor: "#90caf9",
              color: "#0d47a1",
              minWidth: { xs: "auto", sm: 100 },
              boxShadow: 3,
              fontSize: "0.92rem",
              "&:hover": { bgcolor: "#64b5f6", transform: "translateY(-1px)" },
              transition: "all 0.2s",
            }}
          >
            Task Assignment
          </Button>
        </span>
      </Tooltip>
    )}


                  {hasModulePermission("Task Acceptance") && (
      <Tooltip title={selectedTicket ? "Accept Task" : "Navigate to the Task Acceptance Page"} arrow>
        <span>
          <Button
            variant="contained"
            size="small"
            startIcon={<TaskAcceptIcon />}
            onClick={() => navigate(`/task-acceptance`)}
            fullWidth={isMobile}
            sx={{
              borderRadius: "24px",
              textTransform: "none",
              fontWeight: 700,
              height: 36,
              bgcolor: "#a5d6a7",
              color: "#1b5e20",
              minWidth: { xs: "auto", sm: 100 },
              boxShadow: 3,
              fontSize: "0.92rem",
              "&:hover": { bgcolor: "#81c784", transform: "translateY(-1px)" },
              transition: "all 0.2s",
            }}
          >
            Task Acceptance
          </Button>
        </span>
      </Tooltip>
    )}


               {hasModulePermission("Task Status") && (
      <Tooltip title={selectedTicket ? "Update Status" : "Navigate to the Task Status Page"} arrow>
        <span>
          <Button
            variant="contained"
            size="small"
            startIcon={<TaskStatusIcon />}
            onClick={() => navigate(`/task-status`)}
            fullWidth={isMobile}
            sx={{
              borderRadius: "24px",
              textTransform: "none",
              fontWeight: 700,
              height: 36,
              bgcolor: "#ce93d8",
              color: "#4a148c",
              minWidth: { xs: "auto", sm: 100 },
              boxShadow: 3,
              fontSize: "0.92rem",
              "&:hover": { bgcolor: "#ba68c8", transform: "translateY(-1px)" },
              transition: "all 0.2s",
            }}
          >
            Task Status
          </Button>
        </span>
      </Tooltip>
    )}
              </Box>
            </Box>
          </Box>
        </Grow>

        {/* Stats Grid */}
        <Grid container spacing={1.5} sx={{ mb: 2 }}>
          {ticketDetails.map((ticket, index) => (
            <Grid item xs={12} sm={6} md={2} key={index}
              sx={{
                display: 'flex',
              }}
            >
              <Grow in={!loading} timeout={index * 200 + 500}>
                <Box sx={{ width: '100%' }}>
                  <StatCard {...ticket} />
                </Box>
              </Grow>
            </Grid>
          ))}
        </Grid>
        {/* Dashboard Content */}
        <Grid container spacing={2}>
          <Grid item xs={12} lg={12}>
            <MultipleCards
              rows={rows}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              selectedTicket={selectedTicket}
              handleRowClick={handleRowClick}
              getStatusChip={getStatusChip}
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
              selectedCategoryId={selectedCategoryId}
              setSelectedCategoryId={setSelectedCategoryId}
            />
            <Grow in={!loading} timeout={1200}>
              <div>
                <Paper elevation={4} sx={{
                  borderRadius: '16px',
                  overflow: 'hidden',
                  height: 'auto',
                  border: `1px solid ${theme.palette.divider}`,
                  '&:hover': {
                    boxShadow: theme.shadows[6]
                  },
                  transition: 'all 0.3s ease'
                }}>
                  <Box sx={{
                    p: 2,
                    bgcolor: theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[100],
                    borderBottom: `1px solid ${theme.palette.divider}`,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}>
                    <Typography variant="h6" sx={{
                      fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1, fontSize: {
                        xs: '1rem',
                        sm: '1rem',
                        md: '1.25rem'
                      }
                    }}>
                      <TrendingUpIcon color="info" /> Weekly Tickets Trend
                    </Typography>
                    <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                      Last updated: {lastUpdated.toLocaleTimeString()}
                    </Typography>
                  </Box>
                  <Box sx={{ p: 0, height: { xs: '600px', sm: '350px', md: '350' } }}>
                    <LiveTicketsGraph
                      globalProperty={globalProperty}
                      selectedCategory={selectedCategory}
                      selectedWarden={selectedWarden}
                      fromDate={fromDate}
                      toDate={toDate}
                      selectedStatus={selectedStatus}
                    />
                  </Box>
                </Paper>
              </div>
            </Grow>
          </Grid>
          {/* Right Column */}
          <Grid item xs={12} lg={12}>
            <Grow in={!loading} timeout={1600}>
              <div>
                <Paper elevation={4} sx={{
                  borderRadius: '16px',
                  overflow: 'hidden',
                  height: 'auto',
                  border: `1px solid ${theme.palette.divider}`,
                  '&:hover': {
                    boxShadow: theme.shadows[6]
                  },
                  transition: 'all 0.3s ease'
                }}>
                  <Box sx={{
                    p: 2,
                    bgcolor: theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[100],
                    borderBottom: `1px solid ${theme.palette.divider}`,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}>
                    <Typography variant="h6" sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1 }}>
                      <EqualizerIcon color="primary" /> Resolution Trend
                    </Typography>
                    <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                      Last 30 days
                    </Typography>
                  </Box>
                  <Box sx={{ p: 0, height: '400px' }}>
                    <TktOvrTimeGraph
                      globalProperty={globalProperty}
                      selectedCategory={selectedCategory}
                      selectedWarden={selectedWarden}
                      fromDate={fromDate}
                      toDate={toDate}
                    />
                  </Box>
                </Paper>
              </div>
            </Grow>
          </Grid>
        </Grid>
        {/* Last updated footer */}
        <Fade in={!loading} timeout={1800}>
          <Box sx={{
            mt: 3,
            p: 2,
            bgcolor: theme.palette.background.paper,
            borderRadius: '12px',
            boxShadow: theme.shadows[1],
            textAlign: 'center'
          }}>
            <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
              Data last updated: {lastUpdated.toLocaleString()} • Auto-refresh in 5 minutes
            </Typography>
          </Box>
        </Fade>
        {/* Ticket Dialog */}
        <TicketDialog
          open={dialogType === "total"}
          onClose={handleCloseDialog}
          globalProperty={globalProperty}
          selectedCategory={selectedCategory}
          selectedWarden={selectedWarden}
          fromDate={fromDate}
          toDate={toDate}
          selectedStatus={selectedStatus}
        />
        <UnassignedTktDlog
          open={dialogType === "open"}
          onClose={handleCloseDialog}
          globalProperty={globalProperty}
          selectedCategory={selectedCategory}
          selectedWarden={selectedWarden}
          fromDate={fromDate}
          toDate={toDate}
          selectedStatus={selectedStatus}
        />
        <InProgTktDlog
          open={dialogType === "inProgress"}
          onClose={handleCloseDialog}
          globalProperty={globalProperty}
          selectedCategory={selectedCategory}
          selectedWarden={selectedWarden}
          fromDate={fromDate}
          toDate={toDate}
          selectedStatus={selectedStatus}
        />
        <ClosedTktDlog
          open={dialogType === "closed"}
          onClose={handleCloseDialog}
          globalProperty={globalProperty}
          selectedCategory={selectedCategory}
          selectedWarden={selectedWarden}
          fromDate={fromDate}
          toDate={toDate}
          selectedStatus={selectedStatus}
        />
        <ResolvTktDlog
          open={dialogType === "resolved"}
          onClose={handleCloseDialog}
          globalProperty={globalProperty}
          selectedCategory={selectedCategory}
          selectedWarden={selectedWarden}
          fromDate={fromDate}
          toDate={toDate}
          selectedStatus={selectedStatus}
        />
      </Box>
    </Box>
  );
};

export default DashTicket;